import { Component, Input } from '@angular/core';


/**
 * Renders an in-app link to a customer's detail page, showing "First Last",
 * for list-report cells whose customer is always present (otherwise use
 * <app-nullable-customer-link>). The host is display:contents (see the css)
 * so it adds no element box.
 */
@Component({
  selector: 'app-customer-link',
  templateUrl: './customer-link.component.html',
  styleUrls: ['./customer-link.component.css'],
})
export class CustomerLinkComponent {
  @Input() customerId: number | string;
  @Input() firstName: string;
  @Input() lastName: string;

  // Optional sub-route beneath the customer ('payments'). A path with child
  // routes ('reservations/bookings') is split below: the router encodes each
  // array entry as one segment, so passing it whole yields "%2F".
  @Input() section: string | null = null;


  get routerLink(): string[] {
    const id = (this.customerId === null || this.customerId === undefined)
      ? ''
      : this.customerId.toString();
    return this.section
      ? ['/customers', id, ...this.section.split('/')]
      : ['/customers', id];
  }
}
